/**
 * Wave 7 / Lot B — en-tête canonique des écrans du portail.
 *
 * Un H1 par écran, au même endroit, dans la même typo, et les actions de page
 * (1 primaire, 2 secondaires au maximum) à côté du titre plutôt que dispersées
 * dans le contenu. Les 12 routes passent par ici — c'est ce qui rend le « H1
 * unique » vérifiable par un test plutôt que par relecture.
 */
import type { ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  /** 1 CTA primaire, 2 secondaires au maximum. */
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: Props) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h1 className="font-display text-3xl font-bold text-ink">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
